<div style="margin: 20px;">
  <h2>Hot Parking</h2>
  <div class="ui-g ui-fluid">
    <div class="ui-g-12">
      <label>W celu dopisania się do listy Hot Parking należy wypełnić tylko jedno z dostępnych pól.</label>
    </div>
    <div class="ui-g-12">
      <label>Numer karty:</label>
      <input #sn pInputText [(ngModel)]="serialNumber" (focus)="licensePlate = '';"/>
      <label>Numer tablicy rejestracyjnej:</label>
      <input #lp pInputText [(ngModel)]="licensePlate" (focus)="serialNumber = '';"/>
    </div>
    <div class="ui-g-12 ui-md-6">
      <p-button (click)="addHotParkingPosition()" label="Dodaj do listy Hot Parking"></p-button>
    </div>
  </div>
</div>
